import { useRef, useEffect } from 'react';
// import { getPopupExps } from '../utils/experiment';

/**
 * 弹窗展示时锁定 body/html 滚动。
 * enableOptimizeScroll 开启时默认不锁；全屏弹窗始终锁定底层页面滚动。
 */
export function useBodyScrollLock(options: {
  /** 弹窗是否展示，为 true 时锁定滚动 */
  show: boolean;
  responseData?: any;
  /** 弹窗配置，用于判断全屏模式 */
  settings?: any;
}) {
  const { show, responseData, settings } = options;
  const savedBodyOverflow = useRef<string | null>(null);
  const savedHtmlOverflow = useRef<string | null>(null);
  // const { enableOptimizeScroll } = getPopupExps({ id: responseData?.id });
  const isFullscreen = settings?.rules?.popupLayoutMode === 'fullscreen';
  const shouldLockScroll =  isFullscreen;

  useEffect(() => {
    if (!shouldLockScroll) return;

    if (show) {
      const bodyStyle = document.body.style;
      if (bodyStyle.overflow !== 'hidden') {
        savedBodyOverflow.current = bodyStyle.overflow;
        bodyStyle.overflow = 'hidden';
      }
      const htmlStyle = document.documentElement.style;
      if (htmlStyle.overflow !== 'hidden') {
        savedHtmlOverflow.current = htmlStyle.overflow;
        htmlStyle.overflow = 'hidden';
      }
    } else {
      if (savedBodyOverflow.current !== null) {
        document.body.style.overflow = savedBodyOverflow.current;
        savedBodyOverflow.current = null;
      }
      if (savedHtmlOverflow.current !== null) {
        document.documentElement.style.overflow = savedHtmlOverflow.current;
        savedHtmlOverflow.current = null;
      }
    }
  }, [show, shouldLockScroll]);

  return {};
}
